export function handleTabs() {
  const tabsContainers = document.querySelectorAll('.category-tabs');

  if (tabsContainers) {
    tabsContainers.forEach((tabsContainer) => {
      const buttons = tabsContainer.querySelectorAll('.button');
      const contentSwipers = tabsContainer.querySelectorAll('.content-swiper');

      if (buttons && contentSwipers) {
        buttons.forEach((button) => {
          button.addEventListener('click', () => {
            buttons.forEach((btn) => btn.classList.remove('-active'));

            const buttonCategory = button.getAttribute('data-button-category');
            button.classList.add('-active');

            contentSwipers.forEach((contentSwiper) => {
              const swiperCategory = contentSwiper.getAttribute('data-swiper-category');
              swiperCategory == buttonCategory
                ? contentSwiper.classList.add('-active')
                : contentSwiper.classList.remove('-active');
            });
          });
        });
      }
    });
  }
}

export function handleTabsSwipers() {
  const contentSwipers = document.querySelectorAll('[data-swiper-category]');

  contentSwipers.forEach((contentSwiper) => {
    const swiperEl = contentSwiper.querySelector('.swiper');
    const carousel = new Swiper(swiperEl, {
      slidesPerView: 2,
      spaceBetween: 16,
      speed: 1000,
      watchOverflow: true,
      preloadImages: false,
      lazy: {
        checkInView: true,
        loadPrevNext: true,
        loadOnTransitionStart: true,
        loadPrevNextAmount: 1,
      },
      navigation: {
        nextEl: contentSwiper.querySelector('.swiper-button-next'),
        prevEl: contentSwiper.querySelector('.swiper-button-prev'),
        disabledClass: '-disabled',
      },
      pagination: {
        el: contentSwiper.querySelector('.swiper-pagination'),
        type: 'bullets',
        clickable: true,
      },
      breakpoints: {
        992: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
      },
    });
  });
}
